<template>
  <div class="content">
    <div class="line_bac"></div>
    <div class="header">
      <i class="el-icon-date"></i>
      <span class="title">活动室管理</span>
    </div>
    <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 70%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column prop="activityRoomName" label="活动室名称" align="center">
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" align="center">
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`徽章类别${title}`"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="form"
          label-width="100px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="活动室名称" prop="activityRoomName">
            <el-input
              v-model="form.activityRoomName"
              placeholder="请输入活动室名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="权重" prop="weight">
            <el-input
              v-model="form.weight"
              placeholder="请输入权重"
              type="number"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="add" @click="confirmSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span>你确定要删除你选中的这条记录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button class="add" @click="confirmDetele">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/pcReservation";
export default {
  name: "badgeCategory",
  data() {
    return {
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      form: {
        activityRoomName: "",
        weight: null
      },
      rules: {
        activityRoomName: [
          {
            required: true,
            trigger: "blur",
            validator: this.validatePass
          }
        ],
        weight: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateWeight
          }
        ]
      },
      title: "新增",
      deleteVisible: false,
      itemId: ""
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    //验证活动室名称
    validatePass(rule, value, callback) {
      console.log(rule, value);
      if (!value) {
        callback(new Error("请输入活动室名称"));
      } else {
        if (this.title == "新增") {
          const typeName = this.tableData.map(item => item.activityRoomName);
          if (typeName.includes(value)) {
            callback(new Error("活动室名称不能重复"));
          } else {
            callback();
          }
          console.log(typeName);
        } else {
          const typeName = this.tableData.filter(
            item => item.id != this.itemId
          );
          const typeNameList = typeName.map(item => item.activityRoomName);

          if (typeNameList.includes(value)) {
            console.log("33333333", typeNameList.includes(value));
            callback(new Error("活动室名称不能重复"));
          } else {
            callback();
          }
          console.log(typeName);
        }
      }
    },
    //验证权重
    validateWeight(rule, value, callback) {
      console.log(rule, value);
      if (!value) {
        callback(new Error("请输入权重"));
      } else {
        value = value.toString();
        var reg = /^((?!0)\d{1,9})$/;
        if (!value.match(reg)) {
          this.form.weight=null
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      }
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    //页码改变
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.itemId = "";
    },
    // 显示 新增
    addBadge() {
      this.title = "新增";
      this.form = {};
      this.dialogVisible = true;
    },
    //显示 编辑
    editBadge() {
      if (this.multipleSelection.length == 1) {
        this.form.activityRoomName = this.multipleSelection[0].activityRoomName;
        this.form.weight = this.multipleSelection[0].weight;
        this.itemId = this.multipleSelection[0].id;

        this.title = "编辑";
        this.dialogVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条类别进行编辑",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要编辑的类别",
          type: "warning"
        });
      }
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.title == "编辑") {
            this.form.id = this.multipleSelection[0].id;
          }
          api.addOrUpdateRoom({ ...this.form }).then(res => {
            if (res.code == 200) {
              this.$message({
                message: this.title + "成功",
                type: "success"
              });
              this.itemId = "";
              this.dialogVisible = false;
              this.queryData();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 显示 删除弹框
    deleteBadge() {
      if (this.multipleSelection.length >= 1) {
        this.deleteVisible = true;
      } else {
        return this.$message({
          message: "请选择需要删除的类别",
          type: "warning"
        });
      }
    },
    //确认删除
    confirmDetele() {
      let ids = []
      this.multipleSelection.forEach(item=>{
        ids.push(item.id)
      })
      api.batchDeleteRoom({ids:ids}).then(res => {
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.deleteVisible = false;
          this.queryData();
        }
      });
    },
    // 查询 列表
    queryData() {
      api.queryActivityRoomPage({ ...this.pageData }).then(res => {
        if (res.code == 200) {
          console.log(11111, res.data);
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #f2fcf9;
  height: 100%;
  .line_bac {
    width: 100%;
    height: 20px;
    background-color: #00ada7;
  }
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background-color: #efefef;
    border-bottom: 4px solid #d0d1d1;
    font-size: 29px;
    ::v-deep {
      .el-icon-date {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
    }
    .title {
      color: #00ada7;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
}
</style>
